import MuiAppBar from "@mui/material/AppBar";
import { styled } from "@mui/material/styles";

export const TopTaskBar = ({ open, position, drawerWidth, children }) => {
  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    height:'56px',
    minHeight:'56px',
    backgroundColor:theme.palette.background.offWhite,
    boxShadow:'0px 0px 25px 0px rgba(0, 0, 0, 0.05)',
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      height:'56px',
      minHeight:'56px',
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  return (
    <AppBar open={open} position={position} style={{minHeight:'56px',}}>
      {children}
    </AppBar>
  );
};
